'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _v = require('./v2.html');

var _v2 = _interopRequireDefault(_v);

var _v3 = require('./v2.controller');

var _v4 = _interopRequireDefault(_v3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var v2Component = {
  restrict: 'E',
  bindings: {},
  template: _v2.default,
  controller: _v4.default,
  controllerAs: 'vm'
};

exports.default = v2Component;


// WEBPACK FOOTER //
// ./client/app/components/v2/v2.component.js